import { Component } from '@grafikr/components';
import fastdom from 'fastdom';
import { debounceTime, fromEvent } from 'rxjs';

export default Component((node) => {
  const scrollEvent = fromEvent(window, 'scroll', { passive: true });
  const resizeEvent = fromEvent(window, 'resize', { passive: true });

  const setHeaderHeight = () => {
    () => {
      let height = 0;

      fastdom.measure(() => {
        height = node.clientHeight;
      });

      fastdom.mutate(() => {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      });
    };
  };

  // Set initial values
  setHeaderHeight();
  // Update values on events
  resizeEvent.pipe(debounceTime(200)).subscribe(setHeaderHeight);

  if (node.hasAttribute('data-is-transparent')) {
    scrollEvent.pipe(debounceTime(25)).subscribe(() => {
      let shouldBeTransparent: boolean | void;

      fastdom.measure(() => {
        shouldBeTransparent = document.documentElement.scrollTop <= 100;
      });

      fastdom.mutate(() => {
        if (typeof shouldBeTransparent !== 'boolean') {
          return;
        }

        node.classList.toggle('text-white', shouldBeTransparent);
        node.classList.toggle('bg-white', !shouldBeTransparent);
        node.classList.toggle('text-black', !shouldBeTransparent);
      });
    });
  }
});
